import { render, staticRenderFns } from "./ApplicationUserMenu.vue?vue&type=template&id=52860d3a&scoped=true"
import script from "./ApplicationUserMenu.vue?vue&type=script&lang=js"
export * from "./ApplicationUserMenu.vue?vue&type=script&lang=js"
import style0 from "./ApplicationUserMenu.vue?vue&type=style&index=0&id=52860d3a&prod&lang=scss"
import style1 from "./ApplicationUserMenu.vue?vue&type=style&index=1&id=52860d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52860d3a",
  null
  
)

export default component.exports